/**
 * Download supplier/company profile (+ optional watchlist row) as JSON.
 */
export function downloadCompanyExport(company, watchlistItem = null) {
  if (!company) return;

  const ticker = company.ticker || company.companyId || 'company';
  const payload = {
    exportedAt: new Date().toISOString(),
    company:
      typeof company.toJSON === 'function'
        ? company.toJSON()
        : {
            ticker: company.ticker,
            name: company.name,
            description: company.description,
            industry: company.industry,
            tier: company.tier,
            sector: company.sector,
            country: company.country,
            website: company.website,
            keywords: company.keywords,
            supplyChainRisks: company.supplyChainRisks,
            riskCategories: company.riskCategories,
            marketCap: company.marketCap,
            employeeCount: company.employeeCount,
            overallRiskScore: company.overallRiskScore,
          },
    watchlist: watchlistItem
      ? {
          priority: watchlistItem.priority,
          notes: watchlistItem.notes,
          alertEnabled: watchlistItem.alertEnabled,
        }
      : null,
  };

  const blob = new Blob([JSON.stringify(payload, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = `${ticker}-export.json`;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}
